module.exports = __webpack_public_path__ + "static/img/fourBox.d2d87ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fourBox.png
// module id = IchB
// module chunks = 1